// @flow
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Container, Row } from 'reactstrap';

import EnterPromoCode from '../../Cart/Payment/EnterPromoCode';
import { appendHoneyGuide } from '../../../lib/utils';
import { TransportationSummary } from '../Common';
import { InjectInvoiceData, Stripe, Page } from '../../../components';

import {
  trackTransportaionCreditUsage,
  trackTransportionPaymentSuccess,
} from '../../../redux/actions/analyticsEventActions';

type Props = {
  history: Object,
  location: Object,
  trackTransportionPaymentSuccess: () => void,
  trackTransportaionCreditUsage: () => void,
};

function TransportationPaymentScreen(props: Props) {
  const { history, location, trackTransportionPaymentSuccess, trackTransportaionCreditUsage } = props;

  const [promocodeResponse, setPromocodeResponse] = React.useState(null);

  const handlePromocodeRespose = (res) => {
    setPromocodeResponse(res);
    try {
      trackTransportaionCreditUsage();
    } catch (e) {
      console.log(e);
    };


  }

  return (
    <Page title={appendHoneyGuide('Transportation Payment')}>
      <InjectInvoiceData>
        {({ lineItems, invoice }) => {
          const { status, id, amount } = invoice;

          return (
            <Container>
              <Row>
                {status.toLowerCase() === 'pending' && (
                  <Stripe
                    invoiceId={id}
                    amount={amount}
                    promocode={promocodeResponse && promocodeResponse.promocode}
                    onSuccess={() => {

                      try {
                        trackTransportionPaymentSuccess(amount);
                      } catch (e) {
                        console.log(e);
                      };

                      history.push({ pathname: `${location.pathname}/payment-success` });
                    }}
                  />
                )}
                <TransportationSummary
                  lineItems={lineItems}
                  invoice={invoice}
                  promocodeResponse={promocodeResponse}
                >
                  <EnterPromoCode
                    invoiceId={id}
                    onSuccess={handlePromocodeRespose}
                    onDelete={() => setPromocodeResponse(null)}
                    isPromocodeApplied={promocodeResponse && promocodeResponse}
                    enterHoneyguideCreditButtonId="transportation-enter-HG-credit-btn"
                    applyHoneyguideCreditButtonId="transportation-apply-hg-credit-btn"
                  />
                </TransportationSummary>
              </Row>
            </Container>
          );
        }}
      </InjectInvoiceData>
    </Page>
  );
}

const ConnectedTransportationPaymentScreen = connect(
  null,
  {
    trackTransportaionCreditUsage,
    trackTransportionPaymentSuccess,
  }
)(TransportationPaymentScreen);

export default withRouter(ConnectedTransportationPaymentScreen);



// WEBPACK FOOTER //
// ./src/screens/Transportation/TransportationPayment/TransportationPaymentScreen.js